var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteModal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-05-26T164506.524",
    "data-name": "svgexport-6 - 2022-05-26T164506.524",
    transform: "translate(0 -0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15197",
    "data-name": "Group 15197",
    transform: "translate(0 0.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15185",
    "data-name": "Group 15185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15184",
    "data-name": "Group 15184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12233",
    "data-name": "Path 12233",
    d: "M43.5,0A43.5,43.5,0,1,0,87,43.5,43.476,43.476,0,0,0,43.5,0Zm0,80.93A37.43,37.43,0,1,1,80.93,43.5,37.473,37.473,0,0,1,43.5,80.93Z",
    fill: "#fa5c7c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_12238",
    "data-name": "Path 12238",
    d: "M34.118,34.1a2.588,2.588,0,0,1-3.643,0L19.464,23.094,8.469,34.1a2.576,2.576,0,0,1-3.643-3.643L15.837,19.467,4.826,8.472A2.576,2.576,0,0,1,8.469,4.829L19.464,15.823,30.459,4.829A2.576,2.576,0,0,1,34.1,8.472L23.107,19.45,34.1,30.445A2.593,2.593,0,0,1,34.118,34.1Z",
    transform: "translate(23.58 23.577)",
    fill: "#fa5c7c",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModal);
export default __webpack_public_path__ + "static/media/delete-modal.7a4386ab0e719ad6646a31146bb2514c.svg";
export { ForwardRef as ReactComponent };